import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const ProductCard = ({ product }) => {
  const { addItem } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!product.inStock) return;
    addItem(product, 1, product.flavors?.[0] || null);
  };

  const hasSale = product.originalPrice && product.originalPrice > product.price;

  return (
    <Link to={`/product/${product.id}`} className="group block bg-white border border-neutral-200 rounded-lg overflow-hidden hover:shadow-xl hover:border-[#0a0a0a] transition-all duration-300">
      <div className="relative aspect-square bg-neutral-50 overflow-hidden">
        {!product.inStock && (
          <Badge className="absolute top-2 left-2 z-10 bg-neutral-900 text-white">Out of Stock</Badge>
        )}
        {hasSale && (
          <Badge className="absolute top-2 right-2 z-10 bg-[#bfff00] text-black font-bold hover:bg-[#bfff00]">SALE</Badge>
        )}
        <img src={product.image} alt={product.name} className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500" loading="lazy" />
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-sm text-neutral-900 line-clamp-2 min-h-[2.5rem] group-hover:text-[#0a0a0a]">{product.name}</h3>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-lg font-bold text-[#0a0a0a]">${product.price.toFixed(2)}</span>
          {hasSale && <span className="text-sm text-neutral-400 line-through">${product.originalPrice.toFixed(2)}</span>}
        </div>
        <Button onClick={handleAdd} disabled={!product.inStock} className="w-full mt-3 bg-[#0a0a0a] hover:bg-neutral-800 text-white font-semibold text-xs uppercase tracking-wide disabled:bg-neutral-300">
          {product.inStock ? 'Add to Cart' : 'Notify Me'}
        </Button>
      </div>
    </Link>
  );
};

export default ProductCard;
